import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';

export interface CurrentMatterByUSStateData {
    statistics: Statistics;
}

export interface Statistics {
    matter: Matter;
}

export interface Matter {
    currentMattersByUsState: CurrentMattersByUsState;
}

export interface CurrentMattersByUsState {
    matterStates:             MatterState[];
    currentMatters:           number;
    totalMatters:             number;
    deadMatters:              number;
    totalMattersWithoutState: number;
}

export interface MatterState {
    state:     string;
    stateType: StateType[];
}

export interface StateType {
    description: string;
    count:       number;
}

export interface CurrentMatterByUSStateParams {
    entityType?: number;
    entityGuid?: string;
    responsibility?: number;
    showAllRecords?: boolean;
    filter?: string;
}

const CurrentMatterByUSStateQuery = gql`
	query CurrentMattersByUsState($entityType: Int, $entityGuid: String, $responsibility: Int, $showAllRecords: Boolean, $filter: String) {
		statistics {
			matter {
                currentMattersByUsState(entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility, showAllRecords: $showAllRecords, filter: $filter) {
                    matterStates {
                        state
                        stateType {
                            description
                            count
                        }
                    }
                    currentMatters
                    totalMatters
                    deadMatters
                    totalMattersWithoutState
                }
            }
        }
    }
`;

export const useMatterByUSStateQuery = (params: CurrentMatterByUSStateParams) => {
    const { data, error, loading } = useQuery<CurrentMatterByUSStateData, CurrentMatterByUSStateParams>(CurrentMatterByUSStateQuery, {
        fetchPolicy: 'network-only',
        variables: {
            entityGuid: params.entityGuid,
            entityType: params.entityType,
            responsibility: params.responsibility,
            showAllRecords: params.showAllRecords,
            filter: params.filter
        },
    });

    return {
        data,
        error,
        loading,
    };
};
